import React, { Component, useEffect, useState, forwardRef, useRef, useImperativeHandle } from 'react';
import { qr_code } from '../../Images';
import moment from 'moment';
import { REACT_APP_BASE_URL } from '../../Constants';


const PrintDelivery = forwardRef((props, ref) => {
    const { getState, login } = props;
    const pageStyle =" @page { size: A4 portrait; margin: 20;}";
    const [qrCode, setQrCode] = useState("");
    const base_url = REACT_APP_BASE_URL;

    useEffect(() => {
        let word = `${base_url}estatement/delivery/${getState.delivery_number}`;
        setQrCode
     ('https://api.qrserver.com/v1/create-qr-code/?data=' + word+ '&size=400x400&bgcolor=ffff');
    },[getState]);
    
    let total = 0;
    for(const x in getState.detail){
        total += getState.detail[x].open_qty;
    }
    return (
        
        <div id="content" ref={ref} style={{color: '#000'}}>
            <style>{pageStyle}</style>
            <div style={{display: 'flex', flexWrap:'wrap', padding: 15}} >
                <div style={{width: '50%'}}>
                    <h2 style={{color: '#000'}}>{login.BPLFrName}</h2>
                    {login.legal_name && <h4>{login.legal_name}</h4>}
                    <p style={{fontSize: 18}}>{login.Address}
                         &nbsp;Telp {login.phone}</p>
                </div>
                <div style={{width: '15%'}}></div>
                <div style={{width: '35%', textAlign: 'right'}}>
                    <div style={{display: 'flex', flexWrap:'wrap', padding: 0}} >
                        <div style={{width: '65%', paddingRight:10,marginRight:0}}>
                            <h2 style={{fontSize: 18, fontWeight: 'bold'}}>{getState.order_type == "Delivery Note" ? "No Delivery" : "No Receipt"}<br/>
                            {getState.delivery_number}</h2>
                            <p style={{margin: 0}}>Tgl Dikirim : { moment(getState.delivery_date).format('DD MMMM YYYY') }</p>
                        </div>
                        <div style={{width: '35%', paddingLeft:0, marginLeft: 0}}>
                            <img src={qrCode} width={100}  />
                        </div>
                    </div>
                    
                </div>
               
            </div>
            <div className='row justify-content-center' >
                <div style={{fontSize: 24, fontWeight: 'bold', color: '#000', textTransform: 'uppercase'}}> {getState.order_type}</div>
            </div>
            <hr />
            <div className='row justify-content-start'>
                <table style={{marginLeft: 41}}>
                    <thead>
                        <tr>
                            <td>Customer</td>
                            <td width={20}>:</td>
                            <td style={{color: '#000'}}>{getState.nama_customer}</td>
                        </tr>
                        <tr>
                            <td style={{paddingRight: 10}}>Shiping Address</td>
                            <td width={20}>:</td>
                            <td style={{color: '#000'}}>{getState.shipping_address}</td>
                        </tr>
                        <tr>
                            <td style={{paddingRight: 10}}></td>
                            <td width={20}></td>
                            <td style={{color: '#000'}}>{getState.shipping_city}, {getState.shipping_country}</td>
                        </tr>
                        <tr>
                            <td>Phone</td>
                            <td width={20}>:</td>
                            <td style={{color: '#000'}}>{getState.shipping_phone =="" ? "-" : getState.shipping_phone}</td>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
                {/* <div style={{fontSize: 21, fontWeight: 'bold', paddingLeft: 30}}>
                     Customer : {getState.nama_customer}
                </div> */}
            </div>

            <div className='row' style={{margin: 10, padding: 10}}>
                {getState.print_count > 0 &&
                    <div style={{position: "fixed", opacity: "0.2", fontSize: "300px", letterSpacing: "30px", top: "200px", left: "50px", color: "#949494", fontFamily: "serif", transform: "rotate(45deg)"}}>
                        COPY
                    </div>
                }
                <table className='table'>
                    <thead>
                        <tr>
                            <td style={{color: '#000'}}>NO</td>
                            <td style={{color: '#000'}}>Product</td>
                            <td style={{color: '#000'}}>Quantity</td>
                        </tr>
                    </thead>
                    <tbody>
                    {getState.detail.map((row, index) => 
                        (
                        <tr key={`tr-` + index} style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1}}>
                                <td style={{borderTop: 'none', color: '#000'}}>{index+1}</td>
                                <td style={{borderTop: 'none', color: '#000'}}>{row.itemname}</td>
                                <td style={{borderTop: 'none', color: '#000'}}>{row.open_qty}</td>
                        </tr>
                    ))}
                        <tr style={{borderStyle: 'solid', borderColor: 'GrayText', borderWidth: 1}}>
                            <td style={{borderTop: 'none', textAlign: 'right',paddingTop: 0, paddingBottom: 5, color: '#000'}} colSpan={2}>Total</td>
                            <td style={{borderTop: 'none', textAlign: 'left', paddingTop: 0, paddingBottom: 0, color: '#000'}}>{total}</td>
                        </tr>
                       
                    </tbody>
                </table>
                
            </div>
            {getState.print_count > 0 &&
                <div style={{position: "fixed", opacity: "0.2", fontSize: "300px", letterSpacing: "30px", top: "800px", left: "20px", color: "#949494", fontFamily: "serif", transform: "rotate(45deg)"}}>
                        COPY
                </div>
            }
            <div style={{display: 'flex', flexWrap:'wrap', padding: 15}} >
                <div className='row' style={{width: '50%', textAlign: 'center'}}>
                    <div style={{width: '100%', paddingBottom: 100}}>Tanda Tangan Konsumen</div><br/>
                    <div style={{width: '100%'}}>______________________</div>
                </div>
                <div className='row' style={{width: '50%', textAlign: 'center'}}>
                    <div style={{width: '100%', paddingBottom: 100}}>Tanda Tangan Toko</div><br/>
                    <div style={{width: '100%'}}>______________________</div>
                </div>
            </div>
        </div>
  )
});

export default PrintDelivery;